import axiosInstance from '@/lib/axios';

export type NotificationPromptEvent =
  | 'prompt_shown'
  | 'prompt_accepted'
  | 'prompt_dismissed'
  | 'token_registered'
  | 'token_registration_failed';

export async function logNotificationPromptEvent(
  event: NotificationPromptEvent,
  details?: Record<string, unknown>
): Promise<void> {
  try {
    await axiosInstance.post('/api/user/notification-prompt-events', {
      event,
      platform: navigator.userAgent.includes('MiloraApp') ? 'native' : 'web',
      ...details,
    });
  } catch (error) {
    console.warn('[NotificationPrompt] Failed to log event:', event, error);
  }
}
